<template>
    <div class="padTop CardContainerComponent">
        <div class="cardwithlink">
            <div class="card cardwithlink default " style="height: 182px;">
                <a :href="link">
                    <div class="content">
                        <div class="topSection" style="height: 130px;">
                            <div class="cardTitle">{{ title }}
                            </div>
                            <div class="cardExcerpt">
                                <p>
                                    {{ description }}
                                </p>
                            </div>
                        </div>
                        <div class="btmleft">
                            <i class="fas fa-calendar-alt pull-left"></i><span class="calendartext">Planned for {{date }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
// Hima, Do this one

export default {
  name: "Card",
  props: {
    title: String,            
    description: String,
    date: String,
    id: String,
    link: String
  },
};
</script>
<style scoped lang="scss">
    /* css for trimming multi-line text on the card Title and Excerpt*/
    #rsji-actions {
        .cardwithlink {
            a {
                color: #000 !important;
                text-decoration: none !important;
            }

            .content {
                .cardExcerpt p {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .cardTitle {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }
        }
    } 
</style>
